/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Rename_ErrorInputs */

const en_dialog_rename_error = /** @type {(inputs: Dialog_Rename_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename audio failed`)
};

const es_dialog_rename_error = /** @type {(inputs: Dialog_Rename_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al renombrar el audio`)
};

/**
* | output |
* | --- |
* | "Rename audio failed" |
*
* @param {Dialog_Rename_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_rename_error = /** @type {((inputs?: Dialog_Rename_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Rename_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_rename_error(inputs)
	return en_dialog_rename_error(inputs)
});